var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"cube-drawer-item border-bottom-1px",class:_vm.itemClass,on:{"click":function($event){_vm.clickItem(_vm.item)}}},[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.item.text || _vm.item)+"\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-660b68f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/cube-ui/src/components/drawer/drawer-item.vue
// module id = null
// module chunks = 